'use strict'

import ApiClient from './ApiClient'

export default class MobileSettingRepository {
  /**
   * モバイルコンテンツ設定を取得
   * @returns {*}
   */
  get () {
    return ApiClient().get(`/mbcsettings`)
  }

  /**
   * モバイルコンテンツ設定を更新
   * @param params sendData
   * @returns {*}
   */
  put (params) {
    return ApiClient().put(`/mbcsettings`, params)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/MobileSettingRepository.js